import axios, { isCancel } from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { VUE_APP_BASE_API } from "@/config";
let debug = false,
  timeoutTimer = null,
  reLoginTimer = null,
  requsetCancelList = [];
window._requsetCancelList = requsetCancelList;
const service = axios.create({
  baseURL: VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000,
});

service.interceptors.request.use(
  config => {
    config.headers["Authorization"] = getToken();
    if (config.method === "get") {
      config.headers["Content-Type"] = "application/json; charset=UTF-8";
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    debug && console.log("response", response);
    // if the custom code is not 200, it is judged as an error.
    if (res.code == 200 && res.success) {
      return res;
    } else if (res.code == 401) {
      if (reLoginTimer) return;
      let message = res.message || "登录信息已经过期，请重新登录";
      reLoginTimer = setTimeout(() => {
        Message({
          message,
          type: "error",
          showClose: true,
        });
        if (getToken()) {
          store.dispatch("user/logout");
        }
        window.clearTimeout(reLoginTimer);
        reLoginTimer = null;
      }, 1000);
      return Promise.reject(message);
    } else {
      const message = res.message || res.msg || "服务器异常!";
      Message({
        message,
        type: "error",
        showClose: true,
      });
      if (res.code >= 500 && res.code < 999) {
        return Promise.reject(message);
      } else {
        return Promise.reject(res);
      }
    }
  },
  error => {
    debug && console.error(error);
    // if (debug) {
    //   try {
    //     console.log("error info start");

    //     console.log("error : ", error);
    //     for (const key in error) {
    //       if (Object.hasOwnProperty.call(error, key)) {
    //         console.log("error[" + key + "]:", error[key]);
    //       }
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    //   console.log("error info end");
    // }
    let { message } = error;
    if (error.code === "ERR_CANCELED") {
      return;
    } else if (error.code === "ERR_NETWORK") {
      message = "服务器异常";
    } else if (error.code === "ECONNABORTED" || message.includes("timeout") || message.includes("Timeout")) {
      if (!timeoutTimer) {
        message = "请求超时";
        timeoutTimer = setTimeout(() => {
          Message({
            message,
            type: "error",
            showClose: true,
          });
          window.clearTimeout(timeoutTimer);
          timeoutTimer = null;
        }, 1000);
      }
      return;
    } else if (error.response?.data?.message) {
      message = error.response.data.message;
    }
    debug && console.log("response error", error.response?.data?.message);
    Message({
      message: message || "服务器异常",
      type: "error",
      showClose: true,
    });
    error.message = message || "服务器异常";
    return Promise.reject(error);
  }
);

export default service;
